import { getPaddingString, toRGBA } from "../parser/utils";
import { getFinalUrl } from "../Image/image-html";
import { ALIGN_MAPPING } from "../constanst";

export default ({ data, id }) => {
  const { backgroundColor, color, borderRadius, align = "center", linkNewTab, width, autoWidth, contentID, linkUrlType } = data;

  const finalUrl = getFinalUrl(data);
  
  return `
    <div id="${contentID || id}" style="display: flex; width: 100%; justify-content: ${ALIGN_MAPPING[align]}">
      <a
        target="${linkNewTab? '_target': '_self'}"
        data-link-type="${linkUrlType}" 
        style="display:inline-block;text-decoration:none;${getPaddingString(data)};background-color:${toRGBA(backgroundColor)};color:${toRGBA(color)};border-radius:${borderRadius}px;width:${autoWidth ? "auto" : width + "%"};"
        href="${finalUrl}"
      >
        ${data.html}
      </a>
    </div>`;
};
